import { useState, type CSSProperties } from 'react'
import { BackofficeExecutionGrid } from '@/components/backoffice/ExecutionSection'
import { PEExecutionGrid } from '@/components/productengineering/ExecutionSection'

type Tab = 'backoffice' | 'pe'

export function ProcessSection() {
  const [tab, setTab] = useState<Tab>('backoffice')

  return (
    <section
      id="process"
      className="bg-white pt-16 sm:pt-24 xl:pt-[200px]"
      aria-labelledby="process-heading"
    >
      <div className="container-site">
        {/* Header */}
        <div className="mb-10 flex flex-col items-center justify-center">
          <span
            className="block text-center font-sans text-[13px] font-bold not-italic uppercase tracking-[0.061px] text-[#C8464B] sm:text-[15px] xl:text-[18px]"
            style={{ leadingTrim: 'both', textEdge: 'cap' } as CSSProperties}
          >
            Our Process
          </span>
          <h2
            id="process-heading"
            className="mx-auto mt-6 w-full max-w-[1002px] text-center font-sans text-[28px] font-medium not-italic leading-[36px] tracking-[-1px] text-[#2D2D2D] sm:text-[36px] sm:leading-[44px] xl:mt-10 xl:text-[48px] xl:leading-[55px]"
          >
            Built Around Execution.
          </h2>
          <p className="mx-auto mt-2 w-full max-w-[1100px] text-center font-sans text-[18px] font-medium not-italic leading-[26px] tracking-[-1px] text-[#6E739D] sm:text-[26px] sm:leading-[34px] xl:text-[48px] xl:leading-[55px]">
            Processes designed to support scalable product development and long-term technology
            operations.
          </p>
        </div>

        {/* Tab switcher — radio pill group */}
        <div className="mb-6 flex items-center justify-center xl:mb-10">
          <div className="flex items-center rounded-full bg-[#FAFAFA]">
            {(['backoffice', 'pe'] as Tab[]).map((t) => {
              const label = t === 'backoffice' ? 'Technology Backoffice' : 'Product Engineering'
              const isActive = tab === t
              return (
                <button
                  key={t}
                  onClick={() => setTab(t)}
                  className="rounded-full px-2.5 py-1.5 font-sans font-normal not-italic leading-normal transition-all duration-200 text-[13px] sm:px-3 sm:py-2 sm:text-[15px] xl:px-4 xl:py-[10px] xl:text-[20px]"
                  style={
                    isActive
                      ? {
                          border: '1px solid #E3E3E3',
                          background: '#FFF',
                          boxShadow: '0 4px 14px 0 rgba(0,0,0,0.04)',
                          color: '#000',
                        }
                      : {
                          border: '1px solid transparent',
                          background: 'transparent',
                          color: 'rgba(0,0,0,0.56)',
                        }
                  }
                >
                  {label}
                </button>
              )
            })}
          </div>
        </div>

        {/* Grid — swap on tab click */}
        {tab === 'backoffice' ? <BackofficeExecutionGrid /> : <PEExecutionGrid />}
      </div>
    </section>
  )
}
